export default defineNuxtRouteMiddleware(to => {
  console.log('0_auth.global.ts')

  const toPath = to.path

  const { user: loggedUser, session: userData } = useUserSession()

  if (toPath !== "/") {
    if (!loggedUser.value) {
      console.error('The user is not logged in')
      throw createError({
        statusCode: 401,
        statusMessage: 'Unauthorized',
      })
    }
  }


  return
})
